// React and third-party imports
import React from 'react';
import { FlightTicketPropType } from 'PropTypes';
import { Card, Form, Col, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';

// Constants and handlers
import { DATE_FORMAT_WEB, DATETIME_FORMAT_WEB } from 'Constants/DateFormatConstants';
import { DateTimeFormater } from 'Helpers/DateTimeHelper';

const RequestInformationCard = (props) => {
  const { flyToWorkTicketInfo } = props;
  return (
    <Card className="staff-profile-card">
      <Card.Header>
        <i className="fa fa-info-circle me-2"></i>Request Information
      </Card.Header>
      <Card.Body>
        <Form>
          <Row>
            <Form.Group as={Col}>
              <Form.Label>Requested By Name</Form.Label>
              <Form.Control type="text" defaultValue={flyToWorkTicketInfo.requestedBy?.name} disabled />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>Requested By Email</Form.Label>
              <Form.Control type="text" defaultValue={flyToWorkTicketInfo.requestedBy?.email} disabled />
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col}>
              <Form.Label>Date Requested</Form.Label>
              <Datetime
                timeFormat={false}
                dateFormat={DATE_FORMAT_WEB}
                closeOnSelect
                utc={true}
                inputProps={{ placeholder: DATE_FORMAT_WEB, disabled: true }}
                value={DateTimeFormater(flyToWorkTicketInfo.dateRequested, null, DATE_FORMAT_WEB)}
              />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>Date Created</Form.Label>
              <Datetime
                timeFormat={false}
                dateFormat={DATETIME_FORMAT_WEB}
                closeOnSelect
                utc={true}
                inputProps={{ placeholder: DATE_FORMAT_WEB, disabled: true }}
                value={DateTimeFormater(flyToWorkTicketInfo.created, null, DATETIME_FORMAT_WEB)}
              />
            </Form.Group>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

RequestInformationCard.propTypes = {
  flyToWorkTicketInfo: FlightTicketPropType.isRequired,
};

export default RequestInformationCard;
